<script>
import PrimaryButton from '@/Components/PrimaryButton.vue'
import TextInput from '@/Components/Forms/TextInput.vue'
import SecondaryButton from '@/Components/SecondaryButton.vue'
import Modal from '@/Components/Modal.vue'
import InputLabel from '@/Components/InputLabel.vue'
import { useForm } from '@inertiajs/vue3'
import BaseIcon from '@/Components/Shared/BaseIcon.vue'
import IconEye from '@/Components/Icons/IconEye.vue'
import IconEyeHide from '@/Components/Icons/IconEyeHide.vue'
import IconInformation from '@/Components/Icons/IconInformation.vue'
import IconClose from '@/Components/Icons/IconClose.vue'
import NonClosableModal from '@/Components/Modals/NonClosableModal.vue'

export default {
    props: {
        canResetPassword: {
            type: Boolean,
        },
        status: {
            type: String,
        },
    },
    components: {
        NonClosableModal,
        IconClose,
        IconInformation,
        IconEyeHide,
        IconEye,
        BaseIcon,
        PrimaryButton,
        TextInput,
        SecondaryButton,
        Modal,
        InputLabel
    },
    data() {
        return {
            form: useForm({
                email: '',
                password: '',
                remember: false,
            }),
            passwordVisible: false,
            showPasswordForgottenModal: false,
            formInput: null,
            passwordResetForm: useForm({
                email: '',
            }),
            showModal: false,
            resendEmail: false,
        }
    },
    computed: {
        formValid() {
            return this.form.email && this.form.password && !this.form.processing
        }
    },
    methods: {
        togglePasswordVisibility() {
            this.passwordVisible = !this.passwordVisible
        },
        closeModal() {
            this.showPasswordForgottenModal = false
            this.passwordResetForm.reset()
            this.passwordResetForm.clearErrors()
        },
        confirmPasswordForgotten() {
            this.showPasswordForgottenModal = true
        },
        submitPasswordForm() {
            console.log('gh')
            this.passwordResetForm.post(this.route('password.email'), {
                onSuccess: () => {
                    this.showModal = true
                }
            })
        },
        resendVerification() {
            this.passwordResetForm.post(this.route('password.email')
                , {
                    onFinish: () => {
                        this.resendEmail = true
                    }
                })

        },
        changeEmail() {
            this.showModal = false
            this.passwordResetForm.reset()
        },
        submit() {
            this.form.post(this.route('login'), {
                onSuccess: () => this.form.reset('password'),
            })
        }
    },
}
</script>

<template>
    <section class="login-section">
        <div class="login-container">
            <div class="logo-container">
                <img alt="logo" src="/assets/main-logo.png">
            </div>
            <div class="form-container">
                <form @submit.prevent="submit">
                    <div class="input-group">
                        <div class="input-container">
                            <InputLabel :class="[form.errors.email ? 'error-text' : '']" :value="$t('labels.email')"
                                for="email" />
                            <TextInput id="email" name="email" v-model="form.email"
                                :hasError="Boolean(form.errors.email)" class="input-field" type="text">
                            </TextInput>
                        </div>
                        <div class="input-container">
                            <InputLabel :class="[form.errors.email ? 'error-text' : '']" :value="$t('labels.password')"
                                for="password" />
                            <TextInput id="password" v-model="form.password" :hasError="Boolean(form.errors.email)"
                                :type="passwordVisible ? 'text' : 'password'" autocomplete="current-password"
                                class="input-field">
                                <template #icon>
                                    <div class="password-toggle">
                                        <button type="button" @click="togglePasswordVisibility">
                                            <base-icon v-if="passwordVisible" :height="'20px'" :is-expanded="true"
                                                :width="'20px'">
                                                <icon-eye :color="form.errors.email ? '#D90B0B' : '#6E6E6E'"></icon-eye>
                                            </base-icon>
                                            <base-icon v-else :height="'20px'" :is-expanded="true" :width="'20px'">
                                                <icon-eye-hide
                                                    :color="form.errors.email ? '#D90B0B' : '#6E6E6E'"></icon-eye-hide>
                                            </base-icon>
                                        </button>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg" v-if="form.errors.email">
                                            <path
                                                d="M19.2817 9.65544L14.9292 2.20763C14.8705 2.10662 14.7865 2.02276 14.6853 1.96439C14.5841 1.90603 14.4695 1.87521 14.3527 1.875H5.6473C5.53051 1.87521 5.41582 1.90603 5.31466 1.96439C5.21351 2.02276 5.12942 2.10662 5.0708 2.20763L0.718234 9.65544C0.657176 9.76 0.625 9.87891 0.625 10C0.625 10.1211 0.657176 10.24 0.718234 10.3446L5.0708 17.7924C5.12942 17.8934 5.21351 17.9772 5.31466 18.0356C5.41582 18.094 5.53051 18.1248 5.6473 18.125H14.3527C14.4695 18.1248 14.5841 18.094 14.6853 18.0356C14.7865 17.9772 14.8705 17.8934 14.9292 17.7924L19.2817 10.3446C19.3428 10.24 19.375 10.1211 19.375 10C19.375 9.87891 19.3428 9.76 19.2817 9.65544ZM9.29686 5H10.7031V11.875H9.29686V5ZM9.99998 15.625C9.81456 15.625 9.63331 15.57 9.47914 15.467C9.32497 15.364 9.2048 15.2176 9.13385 15.0463C9.06289 14.875 9.04432 14.6865 9.0805 14.5046C9.11667 14.3227 9.20596 14.1557 9.33707 14.0246C9.46818 13.8935 9.63523 13.8042 9.81709 13.768C9.99894 13.7318 10.1874 13.7504 10.3587 13.8214C10.5301 13.8923 10.6765 14.0125 10.7795 14.1667C10.8825 14.3208 10.9375 14.5021 10.9375 14.6875C10.9375 14.9361 10.8387 15.1746 10.6629 15.3504C10.4871 15.5262 10.2486 15.625 9.99998 15.625Z"
                                                fill="#D90B0B" />
                                        </svg>
                                    </div>
                                </template>
                            </TextInput>
                        </div>
                    </div>
                    <div class="actions">
                        <div class="forgot-password">
                            <button type="button" @click="confirmPasswordForgotten">
                                {{ $t('loginPage.passwordResetPage.forgotPassword') }}
                            </button>
                        </div>
                        <div v-if="form.errors.account" class="error-message">
                            Ihr Konto ist nicht aktiv.
                        </div>
                        <div v-if="form.errors.email" class="error-message">
                            Die E-Mail-Adresse oder das Passwort sind falsch. <br>
                            Bitte versuchen Sie es erneut.
                        </div>
                        <button :class="{ 'enabled': formValid, 'disabled': !formValid }"
                            :disabled="!form.email || !form.password || form.processing" class="login-button"
                            type="submit">
                            {{ $t('buttons.login') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <Modal :closeable="true" :show="showPasswordForgottenModal && !showModal" @close="closeModal">
            <div v-if="!showModal" class="relative flex flex-col w-full gap-8 text-center modal-content">
                <h2 class="m-modal-title">
                    {{ $t('loginPage.passwordResetPage.forgotPasswordTitle') }}
                </h2>

                <p class="text-lg font-normal modal-text">
                    {{ $t('loginPage.passwordResetPage.forgotPasswordPrompt') }}
                    <span class="font-semibold">{{
                        $t('loginPage.passwordResetPage.forgotPasswordPromptBold')
                    }}</span>
                </p>
                <form class="flex flex-col items-center" @submit.prevent="submitPasswordForm">
                    <div class="flex flex-col items-start w-full">
                        <InputLabel :class="[passwordResetForm.errors.email ? 'error-text' : '']"
                            :value="$t('labels.email')" for="email" />
                        <div class="relative w-full">
                            <TextInput id="email" ref="formInput" v-model="passwordResetForm.email"
                                :hasError="Boolean(passwordResetForm.errors.email)"
                                :error-message="passwordResetForm.errors.email" class="block" type="text" />
                        </div>
                    </div>

                    <div class="mt-8 flex justify-center space-x-4 w-[364px]">
                        <SecondaryButton class="flex-1" height="48px" @click="closeModal">{{
                            $t('buttons.cancel')
                        }}
                        </SecondaryButton>
                        <PrimaryButton color="#000000" :class="{ 'opacity-25': form.processing, 'flex-1': true }"
                            :disabled="form.processing" :type="'submit'" textSize="text-sm">
                            {{ $t('buttons.resetPassword') }}
                        </PrimaryButton>
                    </div>
                </form>
            </div>
        </Modal>
        <NonClosableModal :show="showPasswordForgottenModal && showModal" max-width="800">
            <div v-if="showModal" class="flex flex-col w-full gap-8 text-center">
                <h2 class="m-modal-title">
                    {{ $t('loginPage.passwordResetPage.emailSentSuccess') }}
                </h2>
                <p class="text-lg font-normal">
                    <span
                        v-html="$t('loginPage.passwordResetPage.emailSentMessage', { email: '<span class=\'font-semibold\'>' + passwordResetForm.email + '</span>' })"></span>
                </p>
                <div class="flex flex-col items-start gap-2 text-sm">
                    <div class="flex items-baseline ml-[61px]">
                        <p class="mr-1">{{ $t('loginPage.passwordResetPage.emailNotReceived') }}</p>
                        <button class="m-link" @click="resendVerification">
                            {{ $t('loginPage.passwordResetPage.resendEmail') }}
                        </button>
                    </div>
                    <div class="flex items-baseline">
                        <p class="mr-1">{{ $t('loginPage.passwordResetPage.wrongMailEntered') }}</p>
                        <button class="m-link" @click="changeEmail">
                            {{ $t('loginPage.passwordResetPage.changeEmailAddress') }}
                        </button>
                    </div>
                </div>
            </div>
        </NonClosableModal>
    </section>
</template>
<style lang="scss" scoped>
@import "resources/sass/pages/login";
</style>
